import { render } from "./inventoryheadertab.vue?vue&type=template&id=aafd833c"
import script from "./inventoryheadertab.vue?vue&type=script&lang=js"
export * from "./inventoryheadertab.vue?vue&type=script&lang=js"

import "./inventoryheadertab.vue?vue&type=style&index=0&id=aafd833c&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__